import React from 'react';
import { connect } from 'react-redux';
import {
  removeDraftFromQueue as removeDraftFromQueueAction,
} from '../../../supplier-updates-queue/__storeFiles__/actions';
import { Stepper, Step, StepLabel, RaisedButton } from 'material-ui';
import R from 'ramda';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const EditedDraftProgressIndicator = ({ errors, leftNav, goToSendUpdates, openPublishConfirmation, removeDraftFromQueue }) => {
  const firstStepCompleted = !errors.errorExist && !R.isEmpty(leftNav.editHistory);
  const isEditedDraft = leftNav.originFrom === 'edited';
  const isContractDraft = isEditedDraft && leftNav.draftType !== 'template';
  const activeDraft = isContractDraft || !isNilOrEmpty(leftNav.sentPartners);
  const stagedDraft = leftNav.stagedUpdates && leftNav.stagedUpdates.find(obj => obj.source === 'draft');
  return (
    <Stepper activeStep={firstStepCompleted ? 1 : 0}>
      <Step>
        <StepLabel style={{ height: '32px', paddingLeft: 0 }}>
          <div style={{ width: '100%', textAlign: 'center' }}>
            Make Changes
          </div>
        </StepLabel>
      </Step>
      <Step>
        <StepLabel style={{ height: '32px', paddingRight: 0 }}>
          <div style={{ width: '100%', textAlign: 'center' }}>
            {
              stagedDraft ? (
                <RaisedButton
                  primary
                  label="Remove draft from queue to continue editing"
                  style={{ width: '100%' }}
                  labelStyle={{ textTransform: 'none' }}
                  disabled={!firstStepCompleted}
                  onTouchTap={() => removeDraftFromQueue(stagedDraft.sourceId, 'doc')}
                />
              ) : (
                <RaisedButton
                  secondary
                  label={activeDraft ? 'Send Updates to Partners' : 'Finalise Template'}
                  style={{ width: '100%' }}
                  disabled={!firstStepCompleted}
                  onTouchTap={activeDraft ? goToSendUpdates : openPublishConfirmation}
                />
              )
            }
          </div>
        </StepLabel>
      </Step>
    </Stepper>
  );
};
EditedDraftProgressIndicator.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(null, { removeDraftFromQueue: removeDraftFromQueueAction })(EditedDraftProgressIndicator);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/progressIndicatorBar/editedDraft.jsx